import theme from '@lyearn-team/theme-config';
import styled from 'react-emotion';

export const LoginRoot = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
  overflow: auto;
  background-color: ${theme.color.dark.uranus};

  @media only screen and (max-width: 414px) {
    background-color: ${theme.color.dark.saturn};

    &.no-background {
      background: none;
    }
  }
`;
